import VueSlider from 'vue-slider-component';
import getAssetPath from '$utils/getAssetPath';

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
		min: {
			required: false,
			type: Number,
			default: undefined,
		},
		max: {
			required: false,
			type: Number,
			default: undefined,
		},
		interval: {
			type: Number,
			default: undefined,
		},
	},

	components: { VueSlider },

	mounted() {
	},

	data() {
		return {
			updater: 0,
		};
	},

	computed: {
		effectiveMin() {
			const val = this.readProp('min');
			return val !== undefined && val !== null && val !== '' ? Number(val) : 0;
		},
		effectiveMax() {
			const val = this.readProp('max');
			return val !== undefined && val !== null && val !== '' ? Number(val) : 100;
		},
		effectiveInterval() {
			const val = this.readProp('interval');
			return val !== undefined && val !== null && val !== '' ? Number(val) : undefined;
		},

		marks() {
			return {
				min: `< ${this.getValueByInterval(this.effectiveMin) + 1}`,
				max: `+ ${this.getValueByInterval(this.effectiveMax) - 1}`,
			};
		},

		value: {
			get() {
				const modelValue = this.context._value || { min: this.effectiveMin, max: this.effectiveMax };
				return [
					Math.max(this.effectiveMin, Math.min(modelValue.min, this.effectiveMax)),
					Math.max(this.effectiveMin, Math.min(modelValue.max, this.effectiveMax)),
				];
			},
			set(val) {
				const newValue = {min: val[0], max: val[1]};
				if (this.context.node && typeof this.context.node.input === 'function') {
					this.context.node.input(newValue);
				} else if (this.context.handlers && typeof this.context.handlers.input === 'function') {
					this.context.handlers.input(newValue);
				}
			}
		}
	},

	methods: {
		readProp(name) {
			if (this[name] !== undefined && this[name] !== null) return this[name];
			const context = this.context;
			if (!context) return undefined;
			if (context[name] !== undefined) return context[name];
			if (context.node?.props?.[name] !== undefined) return context.node.props[name];
			if (context.attrs?.[name] !== undefined) return context.attrs[name];
			return undefined;
		},

		isMobile() {
			return this.$store.state.isMobile;
		},

		isTablet() {
			return this.$store.state.isTablet;
		},

		getValueByInterval(value) {
			return this.effectiveInterval ? Math.round(value / this.effectiveInterval) : value;
		},

		tooltipValue(value) {
			if (value <= this.effectiveMin) {
				return this.marks.min;
			}
			if (value >= this.effectiveMax) {
				return this.marks.max;
			}

			return this.getValueByInterval(value);
		},

		getBinAssetPath(value, modifier) {
			return getAssetPath(value, modifier);
		},
	},

	watch: {

	}
};
